import * as actions from "../actions/actions";
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import React from "react";
import Payment from "payment";

class EduBilling extends React.Component {
    attemptSubmitForm(e) {
        e.preventDefault();

        if (!this.props.processing) {
            // Don't let users submit twice

            let expMonth, expYear;

            if (this.cardExpirationInput.value.includes("/")) {
                expMonth = this.cardExpirationInput.value.split("/")[0];
                expYear = this.cardExpirationInput.value.split("/")[1];
            } else {
                expMonth = this.cardExpirationInput.value.slice(0, 2);
                expYear = this.cardExpirationInput.value.slice(2, 4);
            }

            let formData = [
                { number: this.cardNumberInput.value },
                { cvc: this.cardCVCInput.value },
                { exp_month: expMonth },
                { exp_year: expYear },
                { name: this.cardNameInput.value }
            ];

            this.props.submit(formData);
        }
    }

    clearErrors() {
        this.setState({
            error: false,
            fieldErrors: {}
        });
    }

    closeAuthentication(e) {
        e.preventDefault();

        hashHistory.push("search");
    }

    componentDidMount() {
        Payment.formatCardNumber(document.querySelector("#card_number"));
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.error) {
            this.setState({
                error: true,
                fieldErrors: nextProps.error
            });
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            error: null,
            fieldErrors: {},
            priceInDollars: "19",
            priceInCents: "99"
        };
    }

    render() {
        let cardNameInputClasses = ["input"],
            cardNumberLabel,
            cardNumberInputClasses = ["input"],
            cardExpirationLabel,
            cardExpirationInputClasses = ["input"],
            cardCvcLabel,
            cardCvcInputClasses = ["input"],
            submitButtonClasses = [
                "button",
                "blue",
                "full-width",
                "ui_arrow-right-line",
                "button-process"
            ],
            inputDisabled;

        if (this.props.processing) {
            submitButtonClasses.push("processing");
            inputDisabled = "disabled";
        }

        if (this.state.fieldErrors.number) {
            cardNumberLabel = (
                <label
                    htmlFor="card_number"
                    className="show error on"
                    style={{ color: "#F44E4E" }}
                >
                    {this.state.fieldErrors.number}
                </label>
            );
            cardNumberInputClasses.push("error on");
        } else {
            cardNumberLabel = (
                <label
                    htmlFor="card_number"
                    data-label-text="Card Number"
                    className="show"
                >
                    Card Number
                </label>
            );
        }

        if (this.state.fieldErrors.card_expiration) {
            cardExpirationLabel = (
                <label
                    htmlFor="card_expiration"
                    className="show error on"
                    style={{ color: "#F44E4E" }}
                >
                    {this.state.fieldErrors.card_expiration}
                </label>
            );
            cardExpirationInputClasses.push("error on");
        } else {
            cardExpirationLabel = (
                <label
                    htmlFor="card_expiration"
                    data-label-text="Card Expiration"
                    className="on show"
                >
                    Card Expiration
                </label>
            );
        }

        if (this.state.fieldErrors.cvc) {
            cardCvcLabel = (
                <label
                    htmlFor="card_cvc"
                    className="show error on"
                    style={{ color: "#F44E4E" }}
                >
                    {this.state.fieldErrors.cvc}
                </label>
            );
            cardCvcInputClasses.push("error on");
        } else {
            cardCvcLabel = (
                <label
                    htmlFor="card_cvc"
                    data-label-text="CVC"
                    className="on show"
                >
                    CVC
                </label>
            );
        }

        return (
            <span>
                <div
                    className="loginView"
                    style={{
                        background: "black",
                        color: "white",
                        padding: "50px 16px 100px",
                        minHeight: "100%"
                    }}
                >
                    <style>{`
                        .loginView .text-link,
                        .loginView .text-link:hover {
                            color: white
                        }
                        .billing-form input{
                            padding: 20px 42px 20px 20px;
                        }
                    `}</style>
                    <form
                        action={`/accounts/login/?next=/plugin/${this.props
                            .host}/#/search`}
                        method="POST"
                        className="new-form dark-form billing-form plugin-form"
                        onSubmit={this.attemptSubmitForm.bind(this)}
                        style={{
                            maxWidth: "600px",
                            margin: "0 auto"
                        }}
                    >
                        <ol>
                            <li>
                                <h2 className="form-header font-medium">
                                    Payment Information
                                </h2>
                            </li>
                            <li className="padding-b-s">
                                <input
                                    className={cardNameInputClasses.join(" ")}
                                    type="text"
                                    name="card_name"
                                    id="card_name"
                                    placeholder="Name on card"
                                    required=""
                                    autoFocus="autofocus"
                                    ref={input => {
                                        this.cardNameInput = input;
                                    }}
                                    onFocus={this.clearErrors.bind(this)}
                                    disabled={inputDisabled}
                                />
                                <label
                                    htmlFor="card_name"
                                    data-label-text="Name on Card"
                                    className="on show"
                                >
                                    Name on Card
                                </label>
                            </li>
                            <li className="padding-b-s">
                                <input
                                    type="text"
                                    id="card_number"
                                    className={cardNumberInputClasses.join(" ")}
                                    placeholder="Credit Card Number"
                                    required=""
                                    ref={input => {
                                        this.cardNumberInput = input;
                                    }}
                                    onFocus={this.clearErrors.bind(this)}
                                    disabled={inputDisabled}
                                />
                                {cardNumberLabel}
                            </li>
                            <li className="padding-b-s">
                                <ul className="display-flex">
                                    <li
                                        className="margin-r-l"
                                        style={{ width: "100%" }}
                                    >
                                        <input
                                            type="text"
                                            name="card_expiration"
                                            id="card_expiration"
                                            className={cardExpirationInputClasses.join(
                                                " "
                                            )}
                                            placeholder="MM/YY"
                                            maxLength="5"
                                            required=""
                                            ref={input => {
                                                this.cardExpirationInput = input;
                                            }}
                                            onFocus={this.clearErrors.bind(
                                                this
                                            )}
                                            disabled={inputDisabled}
                                        />
                                        {cardExpirationLabel}
                                    </li>
                                    <li style={{ width: "100%" }}>
                                        <input
                                            type="text"
                                            id="card_cvc"
                                            placeholder="CVC"
                                            className={cardCvcInputClasses.join(
                                                " "
                                            )}
                                            maxLength="4"
                                            required=""
                                            ref={input => {
                                                this.cardCVCInput = input;
                                            }}
                                            onFocus={this.clearErrors.bind(
                                                this
                                            )}
                                            disabled={inputDisabled}
                                        />
                                        {cardCvcLabel}
                                    </li>
                                </ul>
                            </li>
                            <li className="footer margin-t-l">
                                <div className="price-status">
                                    Total billed today <span id="dash" />{" "}
                                    <span className="cost-total">$19.99</span>
                                </div>

                                <p className="when-you-are-billed">
                                    You will be charged now and yearly at this
                                    time when your account automatically renews.
                                    Cancel automatic renewal any time by going
                                    to your billing.
                                </p>
                            </li>
                        </ol>
                        <button
                            className={submitButtonClasses.join(" ")}
                            type="submit"
                        >
                            <span>Charge card</span>
                        </button>
                    </form>
                </div>
            </span>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let host = state.plugin.host;

    return { host };
}

module.exports = connect(mapStateToProps, {})(EduBilling);
